module.exports = "/assets/ac979fa1d61be95e7f8015dc1259bd0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/J8.png
// module id = 1501
// module chunks = 0